import { ManageableItemsList, RichTextarea } from '@payaca/ambrosia';
import { currencyPrice } from '@payaca/helpers/financeHelper';
import { getPaymentScheduleStagesWithValues } from '@payaca/helpers/paymentScheduleHelper';
import {
  PaymentSchedule,
  PaymentScheduleStage,
} from '@payaca/types/payment-schedule';
import { Nullish } from '@payaca/utilities/types';
import { useMemo } from 'react';
import { useAccount } from '../../../utils/storeHooks';

type PaymentScheduleStageData = Pick<PaymentScheduleStage, 'description'> & {
  percentageDue: string;
  isDeposit: 'Yes' | 'No';
  value?: number;
};

type Props = {
  paymentSchedule: Nullish<PaymentSchedule>;
  projectValue?: number;
};
const PaymentScheduleDefinitionReadView = ({
  paymentSchedule,
  projectValue,
}: Props) => {
  const account = useAccount();

  const tableData = useMemo(() => {
    const stages = paymentSchedule?.stages
      ? getPaymentScheduleStagesWithValues(paymentSchedule, projectValue || 0)
      : [];

    return stages.map((stage) => {
      return {
        ...stage,
        percentageDue: `${stage.percentageDue}%`,
        isDeposit: stage.isDeposit ? 'Yes' : 'No',
      };
    });
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useMemo has a missing dependency: 'projectValue'
  }, [paymentSchedule]);

  return (
    <ManageableItemsList>
      <ManageableItemsList.Table
        uniqueKey="description"
        items={tableData}
        hideEmptyState
        doNotUseFooterRow={
          paymentSchedule?.explainer ? (
            <div className="mx-6 my-2">
              <RichTextarea readOnly value={paymentSchedule.explainer} />
            </div>
          ) : undefined
        }
      >
        <ManageableItemsList.Table.Column<
          PaymentScheduleStageData,
          'description'
        >
          field="description"
          header="Stage"
          className="!whitespace-normal"
        />
        <ManageableItemsList.Table.Column<
          PaymentScheduleStageData,
          'percentageDue'
        >
          field="percentageDue"
          header="Percentage"
        />
        <ManageableItemsList.Table.Column<PaymentScheduleStageData, 'isDeposit'>
          field="isDeposit"
          header="Deposit?"
        />
        {!!projectValue && (
          <ManageableItemsList.Table.Column<PaymentScheduleStageData, 'value'>
            field="value"
            header="Value"
            render={(field) => field && currencyPrice(field, account.region)}
          />
        )}
      </ManageableItemsList.Table>
    </ManageableItemsList>
  );
};

export default PaymentScheduleDefinitionReadView;
